export default "__VITE_ASSET__D$hBnwiy__"